import {PageTransformFn} from '../types'
import {ServerPageData} from '@/src/core/domain/entities/page/page-data'
import {PageType} from '@/src/core/domain/entities/page'

export const brandsTransform: PageTransformFn = async data => {
  const data_ = data as ServerPageData<{brand: {name: string}}>

  const breadcrumbs = [...data_.breadcrumbs]

  if (breadcrumbs.length > 0 && data.type == PageType.BrandProductList) {
    breadcrumbs.push({
      title: data_.content.brand.name,
    })
  }

  data_.breadcrumbs = breadcrumbs

  return data_
}
